import client from '../client'

export async function addToFavorites({ vehicleId }) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/FavoriteVehicles/Add`, {
    headers: { 'Content-Type': 'application/json ' },
    method: 'POST',
    body: JSON.stringify({ vehicleId }),
  })
}
